<template>
  <div class="p-8">
    <div class="flex">
      <div class="flex-1">
        <TextArea
          :id="id"
          autoExpand
          :labelName="labelName"
          :modelValue="modelValue"
          :disabled="disabled || loading"
          :preventEnterDefault="true"
          propClasses="!pr-[30px] max-h-[160px]"
          :rows="1"
          @enter="onEnter"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
      </div>
      <button
        v-if="trimmedValue"
        class="!absolute bottom-[14px] right-[14px]"
        :aria-disabled="disabled || loading"
        aria-label="Send message"
        @click="$emit('send')"
      >
        <send-icon aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import SendIcon from '@/graphics/icons/SendIcon.vue';

export default {
  name: 'MessageComposer',
  components: {
    TextArea,
    SendIcon,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: {
      type: String,
      default: 'message-composer',
    },
    labelName: {
      type: String,
      default: 'Message',
    },
    modelValue: {
      type: String,
      default: '',
    },
    sendLabel: {
      type: String,
      default: 'Send',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    trimmedValue(): string {
      return this.modelValue.trim();
    },
  },
  methods: {
    onEnter() {
      if (this.trimmedValue) this.$emit('send');
    },
  },
};
</script>
